module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"tapdat","short_name":"tapdat","start_url":"/","background_color":"#39B54A","theme_color":"#39B54A","display":"minimal-ui","icon":"src/images/hop-icon.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
